import styled from 'styled-components';
import { Content, BizTitle, Description } from '../styles/journey_styles';
import { device } from './responsives';


export const DisplayCard = styled.div`
  @media ${device.minLaptop}{
    display: grid;
    grid-template-columns: 30% auto 3px 30%;
    height: 316px;
    padding: 0px;
    box-shadow: 2px 4px 4px 1px rgba(0, 0, 0, 0.2);
    border: 1px solid #cacaca;
    border-radius: 8px;
    margin-top: 24px;
  }
  @media ${device.mobileL}{
    grid-template-columns: 100%;
    height: 950px;
    grid-template-rows: 316px 316px 316px;
    margin-top: 16px;
  }
`

export const CardLeft = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  margin: 0px;
  position: relative;
  vertical-align: top;
  @media ${device.mobileL}{
    grid-row-start: 1;
    grid-row-end: 2;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 316px;
  object-fit: cover;
  border-radius: 8px 0px 0px 8px;
`

export const LikeButton = styled.button`
  position: absolute;
  right: 6px;
  top: 8px;
  display: inline-block;
  background-color: Transparent;
  border-style: none;
  object-fit: contain;
`

export const CardCenter = styled.div`
  @media ${device.minlaptop}{
    grid-column-start: 2;
    grid-column-end: 3;
    margin: 0px;
    padding-right: 16px;
    vertical-align: top;
    position: relative;
  }
  @media ${device.mobileL}{
    grid-row-start: 2;
    grid-row-end: 3;
    padding-right: 8px;
  }
`

export const CenterContent = styled(Content)`
  height: 228px;
`

export const Title = styled(BizTitle)`

`

export const Tips = styled(Description)`

`

export const Divider = styled.div`
  grid-column-start: 3;
  grid-column-end: 4;
  margin-top: 16px;
  margin-bottom: 16px;
  width: 1px;
  height: 284px;
  background-color: #d8d8d8;
`

export const CardRight = styled.div`
  @media ${device.minlaptop}{
    grid-column-start: 4;
    grid-column-end: 5;
    vertical-align: top;
  }
  @media ${device.mobileL}{
    grid-row-start: 3;
    grid-row-end: 4;
  }
`

export const ReviewStat = styled.div`
  height: 54px;
  background-color: rgba(142, 142, 147, 0.2);
  padding: 8px;
  margin: 32px 12px 0px 18px;
  box-shadow: ${(props) => props.hover_active ? '1px 1px 6px 1px rgba(19, 78, 117, 1);' : 'gray' };
  @media ${device.mobileL}{
    margin-top: 16px;
  }
`

export const RevStatText = styled.p`
  vertical-align: top;
  color: #4a4a4a;
  font-size: 16px;
  font-family: Avenir-Roman;
  overflow: hidden;
  text-align: center;
  margin: 0px;
  max-height: 48px;
`

export const Reviews = styled.ul`
  list-style: none;
  font-family: Avenir-Roman;
  font-size: 14px;
  color: #4a4a4a;
  padding: 0px 12px 0px 18px;
  line-height: 16px;
  margin: 0px;
`

export const LiRev = styled.li`
  padding-top: 16px;
  word-break: break;
`

export const MissingImg = styled.img`
  display: block;
  margin: 0 auto;
  margin-top: 33px;

`

export const MissingText = styled.p`
  font-family: Avernir-Roman;
  font-size: 16px;
  text-align: center;
  margin: 12px 24px;
  color: #4a4a4a;
`
